import React from 'react'
import { Layout, Card, Button, Tabs, Tag } from 'antd'
import { SaveOutlined, FileTextOutlined, VideoCameraOutlined } from '@ant-design/icons'
import type { TabsProps } from 'antd'
import './DiagnosisWorkspace.css'

const { Sider, Content } = Layout

const DiagnosisWorkspace: React.FC = () => {
  const tabItems: TabsProps['items'] = [
    {
      key: 'diagnosis',
      label: '智能诊断',
      children: (
        <>
          <div className="ai-diagnosis">
            <h3>AI诊断建议</h3>
            {/* AI诊断结果 */}
          </div>
          <div className="knowledge-results">
            <h3>知识库检索结果</h3>
            {/* 知识库检索结果 */}
          </div>
          <div className="rules-validation">
            <h3>规则引擎验证</h3>
            {/* 规则引擎验证结果 */}
          </div>
        </>
      ),
    },
    {
      key: 'treatment',
      label: '治疗方案',
      children: <div>{/* 治疗方案 */}</div>,
    },
  ]

  return (
    <div className="diagnosis-workspace-page">
      <Layout className="workspace-layout">
        <Sider width={300} className="patient-info-sidebar">
          <Card title="患者信息" className="info-card">
            {/* 患者基本信息 */}
          </Card>
          <Card title="症状描述" className="info-card">
            {/* 症状描述 */}
          </Card>
          <Card title="病史信息" className="info-card">
            {/* 病史信息 */}
          </Card>
          <Card title="检查结果" className="info-card">
            {/* 检查结果 */}
          </Card>
        </Sider>

        <Content className="diagnosis-content">
          <Card className="diagnosis-panel">
            <Tabs defaultActiveKey="diagnosis" items={tabItems} />
          </Card>
        </Content>

        <Sider width={300} className="agent-sidebar">
          <Card title="智能体协作" className="agent-card">
            <div className="agent-item">
              <Tag color="blue">医者智能体</Tag>
              <span>诊断中...</span>
            </div>
            <div className="agent-item">
              <Tag color="green">药者智能体</Tag>
              <span>用药建议已生成</span>
            </div>
            <div className="agent-item">
              <Tag color="orange">械者智能体</Tag>
              <span>检查推荐已生成</span>
            </div>
            <div className="agent-item">
              <Tag color="purple">法者智能体</Tag>
              <span>合规检查通过</span>
            </div>
          </Card>
        </Sider>
      </Layout>

      <div className="workspace-actions">
        <Button icon={<SaveOutlined />}>保存诊断</Button>
        <Button icon={<FileTextOutlined />}>开具处方</Button>
        <Button type="primary" icon={<VideoCameraOutlined />}>发起会诊</Button>
      </div>
    </div>
  )
}

export default DiagnosisWorkspace

